import { OrderEntity } from './OrderEntity.model';

export class PatientOrderHistoryResponse {
  orders?: OrderEntity[];
}
